<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: right">
            <el-input
              style="width: 290px;margin-right: 10px;"
              v-model="searchModel.searchKey"
              clearable
              :placeholder="placeholder"
            />
            <el-button
              size="small"
              icon="el-icon-search"
              type="danger"
              @click="loadData"
              >查询</el-button
            >
          </div>
        </el-row>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="Id"
            label="票据记录单号"
            align="left"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="BusinessTitle"
            label="票据项目"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Type"
            label="票据类型"
            align="center"
            width="110"
            :formatter="typeFormatter"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="IsElectronicInvoice"
            label="票据类型"
            align="center"
            :formatter="isElectronicInvoiceFormatter"
            width="110"
          ></el-table-column>
          <el-table-column
            prop="Amount"
            label="票据金额"
            align="right"
            width="100"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>￥{{ scope.row.Amount | rounding }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="UnitName"
            label="票据主体"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="ApplyTime"
            label="申请时间"
            align="center"
            width="140"
          >
            <template slot-scope="scope">
              {{ (scope.row.ApplyTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column
            prop="InvoiceTime"
            label="票据时间"
            align="center"
            width="140"
          >
            <template slot-scope="scope">
              {{ (scope.row.InvoiceTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Status"
            label="状态"
            align="center"
            :formatter="statusFormatter"
            width="90"
          ></el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                v-show="isDisplay(scope.row)"
                @click="innerUpdate(scope.row)"
                type="text"
                size="mini"
                >完成</el-button
              >
              <el-button
                v-access:read
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleQuery
      v-if="formVisible"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleQuery>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleQuery from "@/modules/zjrc/pages/material/invoiceapply/query";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      isloading: false,
      listData: [], //表格数组
      headerRow: "header-row",
      formVisible: false, //弹窗控制
      formTitle: "", //弹窗标题
      formData: {}, //弹窗对象
      total: 0, //数据总条数
      currentPage: 1, //当前页码
      pageSize: 15, //每页条数
      searchModel: { searchKey: "" }, //搜索对象
      placeholder: "票据记录单号 / 票据主体",
    };
  },
  filters: {
    rounding(value) {
      return value.toFixed(2);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      this.isloading = true;
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        SearchKey: this.searchModel.searchKey,
      };
      api.QueryInvoiceApply(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    //按钮搜索
    btnQuery() {
      this.loadData();
    },
    //关键字查找
    search(keyword) {
      this.searchModel.searchKey = keyword;
      this.loadData();
    },
    //查看
    innerEdit(rowData) {
      this.formData = Object.assign({}, rowData);
      this.formTitle = "票据信息详情";
      this.formVisible = true;
    },
    //开票状态
    statusFormatter(item) {
      return item.Status == 0 ? "未开票" : "已开票";
    },
    //开票类型
    typeFormatter(rowData) {
      switch (rowData.Type) {
        case 0:
          return "资金捐赠";
        case 1:
          return "物品捐赠";
        case 2:
          return "培训缴费";
        case 3:
          return "会员缴费";
        case 4:
          return "讲座缴费";
        case 5:
          return "定期捐赠";
      }
    },
    //弹窗回调
    formCallBack(data) {
      this.formVisible = false;
    },
    //每页条数改变
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //页码跳转
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    //表格高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //发票类型
    isElectronicInvoiceFormatter(rowData) {
      return rowData.IsElectronicInvoice ? "电子票据" : "纸质票据";
    },
    //更新开票状态
    innerUpdate(rowData) {
      this.$confirm("您确定已开票据吗？", "确认开票", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api.UpdateInvoiceApply(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "已确认开票",
              type: "success",
            });
            this.loadData();
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        });
      });
    },
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleQuery,
  },
  computed: {
    //是否显示完成按钮
    isDisplay: function () {
      return (rowData) => {
        return rowData.Status == 0 ? true : false;
      };
    },
  },
};
</script>

<style scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-select >>> .el-input__inner {
  width: 3rem;
}

.el-date-editor >>> .el-range-separator {
  padding: 0 !important;
  line-height: 120% !important;
}
</style>

<style >
.searchbox {
  float: left;
  margin-right: 1%;
}
.search {
  float: left;
  padding-right: 5%;
}
</style>
